import { useMemo } from 'react'

import { Rights } from 'app/appUserContextConstants'
import { useAppUserContext } from 'app/useAppUserContext'
import { useAgents } from 'data/hooks/agents/agents'

export function useSideBarAgents() {
    const { data: agents } = useAgents()
    const { hasRight, role } = useAppUserContext()

    const isAdmin = hasRight(Rights.Admin.Agents.Any)

    return useMemo(() => {
        if (isAdmin) return agents
        return agents?.filter(
            (agent) => role && agent.show_in_app_bar_for_roles?.includes(role?.api_name)
        )
    }, [agents, isAdmin, role])
}
